import { render, staticRenderFns } from "./SalesLeadsPage.vue?vue&type=template&id=db7fad56&"
import script from "./SalesLeadsPage.vue?vue&type=script&lang=js&"
export * from "./SalesLeadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports